import { IPromise } from 'angular';
import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ChangeExternalContentContactAction } from '../../../../ts/services/ChangeExternalContentContactAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetContactAction } from '../../../actions/spaces/SetContactAction';
import { ServiceLocator } from '../../../ServiceLocator';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';


export function* handleSetContact(action: SetContactAction) {
  try {
    yield call(openContactDialog, action.item);

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function openContactDialog(externalContentItem: IContentInfo): IPromise<any> {
  const context = ServiceLocator.getAngularActionContext();
  const externalContentService: ChangeExternalContentContactAction =
  ServiceLocator.get<ChangeExternalContentContactAction>('ChangeExternalContentContactAction');
  return externalContentService.confirmChangeContact(externalContentItem.contentType, externalContentItem, context);
}
